const CACHE_PREFIX = 'gamification_cache_';
const DEFAULT_TTL_MS = 15 * 60 * 1000;

const readEntry = (key, ttlMs = DEFAULT_TTL_MS) => {
  try {
    const raw = sessionStorage.getItem(`${CACHE_PREFIX}${key}`);
    if (!raw) return null;
    const envelope = JSON.parse(raw);
    if (!envelope?.cachedAt) return null;
    if (Date.now() - envelope.cachedAt > ttlMs) {
      sessionStorage.removeItem(`${CACHE_PREFIX}${key}`);
      return null;
    }
    return envelope.data ?? null;
  } catch {
    return null;
  }
};

const writeEntry = (key, data) => {
  try {
    sessionStorage.setItem(
      `${CACHE_PREFIX}${key}`,
      JSON.stringify({ data, cachedAt: Date.now() })
    );
  } catch {
    // sessionStorage full or unavailable
  }
};

export const gamificationCache = {
  get(key, ttlMs) {
    return readEntry(key, ttlMs);
  },
  set(key, data) {
    writeEntry(key, data);
  },
  clearAll() {
    try {
      const keysToRemove = [];
      for (let i = 0; i < sessionStorage.length; i += 1) {
        const k = sessionStorage.key(i);
        if (k?.startsWith(CACHE_PREFIX)) keysToRemove.push(k);
      }
      keysToRemove.forEach((k) => sessionStorage.removeItem(k));
    } catch {
      // ignore
    }
  },
};

export const sliceLeaderboardAroundUser = (rows = [], currentUserId, above = 3, below = 3) => {
  const list = Array.isArray(rows) ? rows : [];
  if (!currentUserId || !list.length) return list.slice(0, above + below + 1);

  const myEntry = list.find((e) => String(e.userId) === String(currentUserId));
  if (!myEntry) return list.slice(0, above + below + 1);

  const myRank = Number(myEntry.rank) || 0;
  const minRank = Math.max(1, myRank - above);
  const maxRank = myRank + below;
  return list.filter((e) => {
    const r = Number(e.rank) || 0;
    return r >= minRank && r <= maxRank;
  });
};

export const formatPeriodCountdown = (endDate, locale = 'fr') => {
  if (!endDate) return '';
  const end = new Date(endDate);
  if (Number.isNaN(end.getTime())) return '';
  const diffMs = end.getTime() - Date.now();
  if (diffMs <= 0) return '';
  const totalMinutes = Math.floor(diffMs / 60000);
  const days = Math.floor(totalMinutes / (60 * 24));
  const hours = Math.floor((totalMinutes % (60 * 24)) / 60);
  const minutes = totalMinutes % 60;
  if (days > 0) {
    return new Intl.RelativeTimeFormat(locale, { numeric: 'always' }).format(days, 'day');
  }
  if (hours > 0) {
    return `${hours}h:${String(minutes).padStart(2, '0')}min`;
  }
  return `${minutes}min`;
};
